import {
  ConnectionType,
  IntegrationKind,
} from "@redotech/redo-integrations-core";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const ConnectionSchema = z.object({
  identifier: z.string(),
  displayName: z.string(),
  connectionType: createEnum(ConnectionType),
});

export const IntegrationSchema = z.object({
  identifier: createEnum(IntegrationKind),
  displayName: z.string(),
  displayDescription: z.string().optional(),
  logo: z.string().optional(),
  connections: z.record(z.string(), ConnectionSchema),
});

export type Connection = z.infer<typeof ConnectionSchema>;
export type Integration = z.infer<typeof IntegrationSchema>;
